import type { Event, Category } from '@/types/calendar';
import { displayCategories, formatFeatureDate } from '@calendar/lib/utils';
import Container from '../custom/container';
import Tag from '../custom/tag';

interface ViewFeaturedProps {
  events: Event[]
  className?: string
  categories: Category[]
}

export default function ViewFeatured({ events, categories }: ViewFeaturedProps) {
  return (
    <Container>
      <ul className="app--calendar__view--featured">
      {events.map((event) => {
        const formattedDate = formatFeatureDate(event.date, event.time);

        return (
          <li key={event.id}>
            <div className="flex-col">
              <header>
                <h2>
                  <a href={event.url}>
                    <span></span>
                    {event.title}
                  </a>
                </h2>

                <time>
                  <Tag element="span">{formattedDate}</Tag>
                </time>

                <h3>{displayCategories(event.categories, categories, event.primaryCategory)}</h3>
              </header>

              <span className="learn-more-btn">Learn More</span>
            </div>

            <div className="image-container">
              {event.image?.url && <img src={event.image.url} alt={event.image.alt} />}
            </div>
          </li>
        );
      })}
    </ul>
    </Container>
  );
}
